/* tslint:disable */
/* eslint-disable */
import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { GetContractorPenaltiesQuery } from '../../models/get-contractor-penalties-query';
import { GetContractorPenaltiesQueryResult } from '../../models/get-contractor-penalties-query-result';

export interface ApiContractorPenaltiesGetContractorPenaltiesPost$Params {
      body?: GetContractorPenaltiesQuery
}

export function apiContractorPenaltiesGetContractorPenaltiesPost(http: HttpClient, rootUrl: string, params?: ApiContractorPenaltiesGetContractorPenaltiesPost$Params, context?: HttpContext): Observable<StrictHttpResponse<GetContractorPenaltiesQueryResult>> {
  const rb = new RequestBuilder(rootUrl, apiContractorPenaltiesGetContractorPenaltiesPost.PATH, 'post');
  if (params) {
    rb.body(params.body, 'application/*+json');
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'text/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<GetContractorPenaltiesQueryResult>;
    })
  );
}

apiContractorPenaltiesGetContractorPenaltiesPost.PATH = '/api/ContractorPenalties/GetContractorPenalties';
